module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), (_vm.code == undefined) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "wizard margin-b20 ad",
    class: _vm.step == 1 ? ' past3 ' : _vm.step > 1 ? ' past4 ' : ''
  }, [_c('li', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    class: {
      active: _vm.step == 0, past: _vm.step > 0
    }
  }, [_vm._m(1), _vm._v(" "), _c('small', [_vm._v("Plano e condições")]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    class: {
      active: _vm.step == 1, past: _vm.step > 1
    }
  }, [_vm._m(3), _vm._v(" "), _c('small', [_vm._v("Carga Inicial")]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    class: {
      active: _vm.step == 2, past: _vm.step > 2
    }
  }, [_vm._m(5), _vm._v(" "), _c('small', [_vm._v("Resumo e confirmação")]), _vm._v(" "), _vm._m(6)])])])]), _vm._v(" "), (_vm.msgError) ? _c('div', {
    staticClass: "alert alert-danger margin-b10",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', {
    staticClass: "upper"
  }, [_vm._v("Atenção!")]), _vm._v(" " + _vm._s(_vm.msgError) + ".\n    ")]) : _vm._e(), _vm._v(" "), (_vm.step == 0) ? _c('div', {
    staticClass: "alert alert-warning margin-b10",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', {
    staticClass: "upper"
  }, [_vm._v("Atenção!")]), _vm._v(" Para migrar de plano, favor se\n      atentar nas informações abaixo.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.step == 0 && _vm.user.type == '1') ? _c('b2c', {
    attrs: {
      "type": 'migration',
      "rodosol": true
    },
    on: {
      "migrationPlan": _vm.choosePlan
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step == 0 && _vm.user.type == '2') ? _c('b2b', {
    attrs: {
      "type": 'migration',
      "rodosol": true
    },
    on: {
      "migrationPlan": _vm.choosePlan
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step == 1) ? [(_vm.planId == 31 || _vm.planId == 32) ? _c('choose-recharge', {
    ref: "chooseRecharge",
    attrs: {
      "contract": _vm.contract,
      "newAhesionTax": _vm.newAhesionTax,
      "newVehicleTax": _vm.newVehicleTax,
      "planName": _vm.planName,
      "guaranteeTax": _vm.guaranteeTax,
      "minValue": _vm.minValue
    }
  }) : _c('choose-plan', {
    ref: "choosePlan",
    attrs: {
      "contract": _vm.contract,
      "newAhesionTax": _vm.newAhesionTax,
      "newVehicleTax": _vm.newVehicleTax,
      "planName": _vm.planName,
      "guaranteeTax": _vm.guaranteeTax,
      "newSalesType": _vm.salesOrder.salesType
    }
  })] : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('generic-summary', {
    ref: "GenericSummary",
    attrs: {
      "order": _vm.salesOrder,
      "request": _vm.request,
      "showAddress": true,
      "rodosol": _vm.rodosol,
      "contract": _vm.contractProp,
      "account": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.success) ? _c('div', [(_vm.step != 0) ? _c('div', {
    staticClass: "back-button-box"
  }, [_c('button', {
    staticClass: "btn btn-back",
    on: {
      "click": function($event) {
        return _vm.backStep()
      }
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n          Voltar\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-buttons-box"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_c('i', {
    staticClass: "icon-circle-cancel align-icon-left-white"
  }), _vm._v("\n          Cancelar\n        ")]), _vm._v(" "), (_vm.step < 2) ? _c('button', {
    staticClass: "btn btn-purple add",
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n          Avançar\n          "), _c('i', {
    staticClass: "icon-circle-right align-icon-right-white"
  })]) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('button', {
    staticClass: "btn btn-success end",
    attrs: {
      "title": _vm.cpm.error
    },
    on: {
      "click": function($event) {
        return _vm.startRequest()
      }
    }
  }, [_vm._v("\n          Concluir\n          "), _c('i', {
    staticClass: "icon-tick align-icon-right-white"
  })]) : _vm._e()])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('success-page', {
    attrs: {
      "code": _vm.code,
      "type": 'newVehicle',
      "novoCartao": _vm.novoCartao
    }
  }), _vm._v(" "), _c('error-page', {
    attrs: {
      "code": _vm.code,
      "stepPayment": 1,
      "type": 'newVehicle',
      "salesOrder": _vm.salesResponse
    },
    on: {
      "goToStep": _vm.goToStep
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Novo Plano")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-plans"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Plano e condições")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step",
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('i', {
    staticClass: "icon-avatar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Carga Inicial")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step",
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('i', {
    staticClass: "icon-confirmation-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Resumo e confirmação")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-4556d46a!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/contract/migration-plan.vue
// module id = 2115
// module chunks = 1